import React from 'react';
import ATable from 'antd-mobile/lib/table';



export default class Table extends ATable {}